import { text } from "../utils/i18n";

/**
 * Represents a technique for dialing a list of contacts.
 */
export enum LeadListMode {
  /**
   * Each contact is dialed individually and one after another.
   */
  Sequential = 'sequential',
  
  /**
   * The system attempts to dial each contact in advance.
   */
  Predictive = 'predictive',

  /**
   * The contact was called directly via the lead list's contact list.
   */
  Single = 'single',

  /**
   * Equivalent to null, for querying.
   */
  None = 'none',
}

export function translateLeadListMode(mode: LeadListMode) {
  return {
    [LeadListMode.Predictive]: text`prediktivt`,
    [LeadListMode.None]: text`ej ringlista`,
    [LeadListMode.Single]: text`ej ringlista`,
    [LeadListMode.Sequential]: text`en-efter-en`,
  }[mode] ?? mode;
}
